import React from 'react';
import { connect } from 'react-redux';
import MiniCart from '../Components/MiniCart';
import { toggle, update } from '../Actions/Cart.action';

const MiniCartContainer = props => (<MiniCart {...props} />)
const mapStateToProps = state => ({ ...state.cart })

export default connect(
    mapStateToProps,
    {
        toggle,
        update
    }
)(MiniCartContainer);